import { combineReducers } from 'redux'

import me from './me'
import session from './session'
import loading from './loading'
import contextParameters from './contextParameters'
import menuSearch from './menuSearch'

import pages from './pages'

const reducers = combineReducers({
  me,
  session,
  loading,
  contextParameters,
  menuSearch,
  pages
})

export default reducers
